import { PrimaryLinkButton } from 'apps/wrapper/src/components/shared/buttons/buttons.styles';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { PmsWritebackStatus } from 'apps/wrapper/src/services/appointment/types/pms-writeback-status';
import { FC } from 'react';
import { LabeledSection } from '../labeled-section/labeled-section';
import { PmsStatusSectionSkeleton } from './pms-status-section.skeleton';

export interface PmsStatusSectionProps {
  isLoading: boolean;
  pmsWritebackStatus?: PmsWritebackStatus | null;
  appointmentId?: number | null;
  requestId?: number | null;
}

export const PmsStatusSection: FC<PmsStatusSectionProps> = (props) => {
  const { isLoading, pmsWritebackStatus, appointmentId, requestId } = props;
  const { publishToIframes } = useEventBus();

  const handleEditClick = () => {
    if (requestId) {
      publishToIframes({
        messageType: 'appt-request-preview',
        data: {
          id: requestId
        }
      });
    }

    if (appointmentId) {
      publishToIframes({
        messageType: 'appt-preview',
        data: {
          id: appointmentId
        }
      });
    }
  };

  const renderStatus = () => {
    switch (pmsWritebackStatus) {
      case PmsWritebackStatus.Pending:
        return 'Processing';
      case PmsWritebackStatus.Synced:
        return 'Successful';
      case PmsWritebackStatus.Error:
        return 'Failed';
      default:
        return null;
    }
  };

  if (isLoading) return <PmsStatusSectionSkeleton />;
  if (pmsWritebackStatus == null) return null;

  return (
    <LabeledSection label="Writeback Status">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: '10px'
        }}
      >
        <span style={{ marginRight: '10px' }}>{renderStatus()}</span>
        {pmsWritebackStatus === PmsWritebackStatus.Error && (
          <PrimaryLinkButton
            variant="text"
            onClick={handleEditClick}
            sx={{ justifyContent: 'flex-start' }}
            disableRipple
          >
            View
          </PrimaryLinkButton>
        )}
      </div>
    </LabeledSection>
  );
};
